/* eslint-disable import/prefer-default-export */
import getQueryParam from 'syf-js-utilities/formats/getQueryParam';
function isLLE() {
    return [
        'dev.synchronycredit.com',
        'qa.synchronycredit.com',
        'uat.synchronycredit.com'
    ].includes(window.location.hostname);
}
export const useFeatureFlag = (featureFlags) => {
    if (process.env.NODE_ENV === 'production' && !isLLE()) {
        return featureFlags;
    }
    return Object.keys(featureFlags).reduce((acc, flagName) => {
        try {
            const maybeBoolean = JSON.parse(getQueryParam(flagName));
            if (typeof maybeBoolean === 'boolean') {
                return Object.assign(Object.assign({}, acc), { [flagName]: maybeBoolean });
            }
        }
        catch (err) {
            // Not a boolean. Ignore
        }
        return acc;
    }, featureFlags);
};
